import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { PageHeader } from "@/components/PageHeader";
import { TablePagination } from "@/components/TablePagination";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Skeleton } from "@/components/ui/skeleton";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

const ACTION_COLOR = { create: "default", update: "outline", delete: "destructive" };

export default function ActivityLogs() {
  const { t } = useI18n();
  const [page, setPage] = useState(1);
  const { data, isLoading } = useQuery({ queryKey: ["activity", page], queryFn: async () => (await api.get("/activity-logs", { params: { page, page_size: 20 } })).data });

  return (
    <div className="space-y-6" data-testid="activity-page">
      <PageHeader title={t("act.title")} subtitle={t("act.subtitle")} breadcrumb={[t("crumb.center"), t("act.title")]} />
      <Card>
        <div className="overflow-x-auto">
          <Table>
            <TableHeader><TableRow><TableHead>{t("common.time")}</TableHead><TableHead>{t("common.user")}</TableHead><TableHead>{t("common.action")}</TableHead><TableHead>{t("common.entity")}</TableHead><TableHead>{t("common.details")}</TableHead></TableRow></TableHeader>
            <TableBody>
              {isLoading
                ? Array.from({ length: 8 }).map((_, i) => <TableRow key={i}><TableCell colSpan={5}><Skeleton className="h-8" /></TableCell></TableRow>)
                : (data?.items || []).map((l) => (
                    <TableRow key={l.id} className="hover:bg-muted/50">
                      <TableCell className="text-xs text-muted-foreground">{new Date(l.created_at).toLocaleString()}</TableCell>
                      <TableCell className="font-medium">{l.user_name}</TableCell>
                      <TableCell><Badge variant={ACTION_COLOR[l.action] || "outline"} className="capitalize">{l.action}</Badge></TableCell>
                      <TableCell className="capitalize">{l.entity}</TableCell>
                      <TableCell className="text-sm text-muted-foreground">{l.details}</TableCell>
                    </TableRow>
                  ))}
              {!isLoading && data?.items?.length === 0 && <TableRow><TableCell colSpan={5} className="py-10 text-center text-muted-foreground">{t("act.none")}</TableCell></TableRow>}
            </TableBody>
          </Table>
        </div>
        <TablePagination page={page} pages={data?.pages} total={data?.total} onPage={setPage} />
      </Card>
    </div>
  );
}
